module.exports = __webpack_public_path__ + "6a812413c6343cc64cc499ee02778b2f.png";